import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Beans, Tea, Food, NonFood, MenuArrow } from '../../Icons'
import {
  BottomBarDropDown,
  BottomBarDropDownItem,
  BottomBarDropDownIconContainer,
  BottomBarName
} from '../../../styles/defaults-header'

class AssortmentMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleBack() {
    this.props.onClickBack()
  }

  render() {
    return (
      <BottomBarDropDown child z="1" right>
        <BottomBarName>Assortiment</BottomBarName>

        <BottomBarDropDownItem onClick={this.handleBack.bind(this)}>
          <BottomBarDropDownIconContainer black>
            <MenuArrow size="" />
          </BottomBarDropDownIconContainer>
          Terug
        </BottomBarDropDownItem>

        <Link to="/assortiment/koffie" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Beans size="" />
            </BottomBarDropDownIconContainer>
            Koffie
          </BottomBarDropDownItem>
        </Link>

        <Link to="/assortiment/thee" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Tea size="" />
            </BottomBarDropDownIconContainer>
            Thee
          </BottomBarDropDownItem>
        </Link>

        <Link to="/assortiment/non-food" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <NonFood size="" />
            </BottomBarDropDownIconContainer>
            Non-food
          </BottomBarDropDownItem>
        </Link>

        <Link to="/assortiment/food" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Food size="" />
            </BottomBarDropDownIconContainer>
            Food
          </BottomBarDropDownItem>
        </Link>
      </BottomBarDropDown>
    )
  }
}

export default withRouter(AssortmentMenu)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/AssortmentMenu/index.js